import React from "react";

export default function Sell() {
  return (
    <main className="page">
      <div className="container">
        <div className="page-header">
          <div>
            <h1>List Your Home With Us</h1>
            <p>
              Get a premium, full-service real estate experience backed by
              award-winning marketing, expert pricing strategy, and a proven
              track record in Florida’s top 1% of agents.
            </p>
          </div>
          <div className="page-note">
            Serving Sarasota, Manatee, and surrounding Gulf Coast areas.
          </div>
        </div>

        <div className="contact-grid">
          <form
            action="https://formspree.io/f/xyzvkewl"
            method="POST"
            className="card form-card"
          >
            <input
              type="hidden"
              name="_subject"
              value="New SELLER lead — List Your Home"
            />

            <div className="form-row">
              <div className="form-field">
                <label htmlFor="name">Full Name</label>
                <input type="text" id="name" name="name" required />
              </div>

              <div className="form-field">
                <label htmlFor="phone">Phone</label>
                <input type="tel" id="phone" name="phone" required />
              </div>
            </div>

            <div className="form-field">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" required />
            </div>

            <div className="form-field">
              <label htmlFor="address">Property Address</label>
              <input
                type="text"
                id="address"
                name="address"
                placeholder="Street, city, ZIP"
              />
            </div>

            <div className="form-row">
              <div className="form-field">
                <label htmlFor="timeline">Timeline</label>
                <select id="timeline" name="timeline">
                  <option>ASAP</option>
                  <option>0–30 days</option>
                  <option>1–3 months</option>
                  <option>3–6 months</option>
                  <option>Just exploring</option>
                </select>
              </div>

              <div className="form-field">
                <label htmlFor="value">Estimated Value</label>
                <input
                  type="text"
                  id="value"
                  name="value"
                  placeholder="e.g., $750,000"
                />
              </div>
            </div>

            <div className="form-field">
              <label htmlFor="message">Anything else we should know?</label>
              <textarea
                id="message"
                name="message"
                rows={4}
                placeholder="Renovations, condition, goals, etc."
              />
            </div>

            <button type="submit" className="btn btn-primary">
              Request Listing Consultation
            </button>
          </form>

          <aside className="card contact-card">
            <h2>Why Sellers Choose Us</h2>
            <ul>
              <li>Top 1% producing agents</li>
              <li>Luxury marketing & professional photography</li>
              <li>Strategic pricing for maximum return</li>
              <li>KW and eXp trained — boutique level service</li>
              <li>Hands-on agents, not a franchise</li>
            </ul>

            <p className="page-footnote">
              No pressure. We're here to help you make the smartest move.
            </p>
          </aside>
        </div>
      </div>
    </main>
  );
}
